const INVITATION_KEY = 'legal-web:registration-invitation:v1'
let pendingCode: string | undefined
let loaded = false

/** 邀请码只在当前标签页保存；存储受限时保留内存值。 */
export function readInvitationCode(): string | undefined {
  if (!loaded) {
    try {
      pendingCode = window.sessionStorage.getItem(INVITATION_KEY)?.trim().toUpperCase() || undefined
    } catch {
      // 当前页面仍可使用内存中的邀请码。
    }
    loaded = true
  }
  return pendingCode
}

export function clearInvitationCode(): void {
  pendingCode = undefined
  loaded = true
  try {
    window.sessionStorage.removeItem(INVITATION_KEY)
  } catch {
    // 存储不可用时仍清理当前页面的内存值。
  }
}

/** 返回去掉邀请码的站内地址，防止登录后刷新或退出时重新捕获。 */
export function captureInvitation(url: URL, isAuthenticated: boolean): string | undefined {
  if (!url.searchParams.has('inviteCode')) return undefined
  const code = url.searchParams.get('inviteCode')?.trim().toUpperCase()
  clearInvitationCode()
  if (!isAuthenticated && code) {
    pendingCode = code
    try {
      window.sessionStorage.setItem(INVITATION_KEY, code)
    } catch {
      // 跨页面授权前会检查持久化，避免静默丢失推广归因。
    }
  }
  url.searchParams.delete('inviteCode')
  return `${url.pathname}${url.search}${url.hash}`
}

export function invitationLoginFields(): { inviteCode?: string } {
  const inviteCode = readInvitationCode()
  return inviteCode ? { inviteCode } : {}
}

/** 微信离开当前页面前必须确保邀请码能够在回调时恢复。 */
export function persistInvitationForRedirect(): void {
  const code = readInvitationCode()
  if (!code) return
  try {
    window.sessionStorage.setItem(INVITATION_KEY, code)
    if (window.sessionStorage.getItem(INVITATION_KEY) === code) return
  } catch {
    // 无法保存时中止跳转，用户仍可使用当前页面的短信登录。
  }
  throw new Error('浏览器无法保存邀请信息，请允许站点存储或使用短信登录')
}
